import { Array } from 'effect';
import { LineItemParseService, sumLineItemDiscountTotal, sumLineItemSubTotal } from '../LineItem/LineItemParseService';
const parseCart = (cart) => {
    var _a;
    const items = LineItemParseService.parseLineItems(cart.items);
    const subtotal = Math.round(sumLineItemSubTotal(items));
    const discount_total = Math.round(sumLineItemDiscountTotal(items));
    return {
        ...cart,
        items,
        subtotal,
        discount_total,
        total: subtotal - discount_total + ((_a = cart.shipping_total) !== null && _a !== void 0 ? _a : 0)
    };
};
const parseCarts = Array.map(parseCart);
export const CartParseService = {
    parseCarts,
    parseCart
};
